import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPreference } from '../../utilities/common';
import { getBranchList } from '../../actions/commonAction';
import { handleLastStateStatistics, openLastStateStatistics, showAlertSnackbar } from '../../reducers/uiSlice';
import { getDeliverReturn, getLastStateStatistics, getWrongRouteOrders } from '../../actions/lastStateStatisticsActions';
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { CircularProgress, Grid } from '@material-ui/core';
import {MenuItem, Select} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import UniDialog from '../Common/UniDialog';
import { useTranslation } from 'react-i18next';
import { DataGrid } from '@material-ui/data-grid';
import { RenderCellExpand } from './RenderCellExpand';
import ReactExport from "react-export-excel";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
    buttonStyle: { 
        padding: '10px 10px', 
        marginLeft: 10 
    },
    spanStyle: { 
        display: "inline-block", 
        padding: '0 20px', 
        paddingTop: '5px' 
    },
    select: {
        marginLeft: 10,
        '& .MuiOutlinedInput-input': {
            paddingTop: 12,
            paddingBottom: 12,
            paddingLeft: 10,
            paddingRight: 40
        }
    },
    download: { 
        textDecoration: 'none', color: '#212121'
    }
}));

const moment = require('moment');

function LastStateStatistics() {
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    const classes = useStyles();
    const {t} = useTranslation('lastStateStatistics');
    const dispatch = useDispatch();

    const openModal = useSelector(openLastStateStatistics);

    let userPref = getUserPreference();

    const [branches, setBranches] = useState([]);
    const [branch, setBranch] = useState(userPref.userCity);
    const [state, setState] = useState('200');
    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rows203, setRows203] = useState([]);
    const [rows219, setRows219] = useState([]);
    const [dataDownload, setDataDownload] = useState([]);
    const [count, setCount] = useState(0);
    const [isChecked, setIsChecked] = useState(false);
    const [is219Checked, setIs219Checked] = useState(false);
    const [isLast, setIsLast] = useState(true);
    const [isShown, setIsShown] = useState(true);
    const [newButton, setNewButton] = useState(false);
    const handleClick = event => {
        setIsShown(current => !current);
        setNewButton(current => !current);
      };

    const handleSearch = () => {
        setLoading(true);
        setDisable(true);
        setIsDataLoading(true);
        if(isLast) {
            const dateFromNum = moment(dateFrom).startOf('day').valueOf() / 1000;
            const dateToNum = Math.floor(moment(dateTo).endOf('day').valueOf() / 1000);
            dispatch(getLastStateStatistics(dateFromNum, dateToNum, branch, state))
            .then((res) => {
                setRows(res);
                setCount(res.length);
            })
            .finally(() => {
                setLoading(false);
                setDisable(false);
                setIsDataLoading(false);
            })
        } else if(isChecked){
            const dateFromStr = dateFrom.replaceAll('-','');
            const dateToStr = dateTo.replaceAll('-','');
            dispatch(getDeliverReturn(dateFromStr, dateToStr, branch))
            .then((res) => {
                setRows203(res);
            })
            .finally(() => {
                setLoading(false);
                setDisable(false);
                setIsDataLoading(false);
            })
        } else {
            const dateFromNum = moment(dateFrom).startOf('day').valueOf() / 1000;
            const dateToNum = Math.floor(moment(dateTo).endOf('day').valueOf() / 1000);

            dispatch(getWrongRouteOrders(dateFromNum, dateToNum, branch))
            .then((res) => {
                setRows219(res);
            })
            .finally(() => {
                setLoading(false);
                setDisable(false);
                setIsDataLoading(false);
            })

        }
    }
    function handleDateTo(event){
        const dateToTamp = moment(event.target.value).unix();
        const dateFromTamp = moment(dateFrom).unix();
        if (dateToTamp < dateFromTamp)  {
            setDateTo(dateFrom);
            dispatch(showAlertSnackbar({message: 'End date must be later than start date!', type: 'warning'}))
        } else {
            setDateTo(event.target.value);
        }
    }
    function toggleCheckboxValue() {
        let isCheckedCurr = !isChecked;
        setIsChecked(isCheckedCurr);
        setIs219Checked(false);
    }
    function toggle219CheckboxValue() {
        let isCheckedCurr = !is219Checked;
        setIs219Checked(isCheckedCurr);
        setIsChecked(false);
    }
    const handleWarehouseChange = (event) => {
        setBranch(event.target.value);
    }
    const handleStateChange = (event) => {
        setState(event.target.value);
    };

    useEffect(() => {
        if(openModal) {
            dispatch(getBranchList())
            .then((res) => {
                let branchesCopy = [{name: 'All Warehouses', id: 100}];
                branchesCopy =branchesCopy.concat(res);
                setBranches(branchesCopy);
            })
            setCount(0);
            setBranch(userPref.userCity);
            setState('200');
            setRows([]);
            setRows203([]);
        }
    }, [openModal])
    useEffect(() => {
        setIsLast(!(isChecked || is219Checked))
    }, [isChecked, is219Checked])

    const columns = [
        {field: 'id', headerName: t('sn'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'tno', headerName: t('tno'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'shipping_staff_id', headerName: t('shipping_staff_id'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'name', headerName: t('name'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'phone', headerName: t('phone'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'warehouse', headerName: t('warehouse'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'state', headerName: t('state'), headerAlign: 'center', width: 200, align: 'center'},
        {field: 'reference', headerName: t('refer_to'), headerAlign: 'center', width: 200, align: 'center'},
        {field: 'shipper', headerName: t('shipper'), headerAlign: 'center', width: 200, align: 'center'},
        {
            field: 'update_time', 
            headerName: t('update_time'), 
            headerAlign: 'center', 
            width: 200,
            valueFormatter: (params)=> moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss"),
            align: 'center'
        },
        {
            field: 'pathTime', 
            headerName: t('parcel_scan'), 
            headerAlign: 'center', 
            width: 200,
            valueFormatter: (params)=> moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss"),
            align: 'center'
        },
        {field: 'internal_account_number', headerName: t('account_no'), headerAlign: 'center', width: 200, align: 'center'},
        {field: 'bag_no', headerName: t('bag_no'), headerAlign: 'center', width: 200, align: 'center'},
        {field: 'zip', headerName: t('postal_code'), headerAlign: 'center', width: 200, align: 'center'},
        {field: 'address1', headerName: t('address'), headerAlign: 'center', width: 200, align: 'center'}
    ];

    const columns203 = [
        {field: 'referer', headerName: t('referer'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'tno', headerName: t('tno'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'time200', headerName: t('time200'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'time203', headerName: t('time203'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'pathstr', headerName: t('path_str'), width: 200, headerAlign: 'center', align: 'center', renderCell: RenderCellExpand},
        {field: 'driverid', headerName: t('driver_id'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'state', headerName: t('newest_state'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'update_time', headerName: t('update_time'), headerAlign: 'center', width: 200, align: 'center'}
    ];

    const columns219 = [
        {field: 'tno', headerName: t('tno'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'reference', headerName: t('refer_to'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'warehouse', headerName: t('warehouse'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'wrong_route_warehouse', headerName: t('wrong_route_warehouse'), width: 250, headerAlign: 'center', align: 'center'},
        {
            field: 'wrong_route_time',
            headerName: t('wrong_route_time'),
            valueFormatter: (params) => {
                if (params.value == null) {
                  return '';
                }
               return moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss");
            },
            width: 200, 
            headerAlign: 'center', 
            align: 'center'
        },
        {
            field: 'parcel_scan_time', 
            headerName: t('parcel_scan_time'),  
            valueFormatter: (params) => {
                if (params.value == null) {
                  return '';
                }
               return moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss");
            },
            width: 200, 
            headerAlign: 'center', 
            align: 'center'
        },
        {field: 'latest_state', headerName: t('newest_state'), width: 200, headerAlign: 'center', align: 'center'},
        {field: 'error_message', headerName: t('error_message'), headerAlign: 'center', width: 300, align: 'center'}
    ];

    return (
        <UniDialog
            title={t('title_last_state_statistics')}
            maxWidth='lg'
            disableDefaultButtons
            open={openModal}
            onClose={handleClose}
            fullWidth
        >
            <Grid 
                container 
                alignItems="center"
                justify="center"
                spacing={12}
            >
                <Grid 
                    item 
                    xs={12}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <TextField 
                        size="small"
                        id="searchStartDate"
                        type="date"
                        variant="outlined"
                        value={dateFrom}
                        onChange={(e)=>setDateFrom(e.target.value)}
                    />
                    <span className={classes.spanStyle}>{t('to')}</span>
                    <TextField 
                        size="small"
                        id="searchStartDate"
                        type="date"
                        variant="outlined"
                        value={dateTo}
                        onChange={handleDateTo}
                    />
                    <Select
                        className={classes.select}
                        defaultValue={userPref.userCity}
                        displayEmpty
                        variant="outlined"
                        onChange={handleWarehouseChange}
                    >
                        {
                            (branches).map((branch, index) => {
                                return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                            })
                        }
                    </Select>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                        <Checkbox
                            checked={isChecked}
                            onClick={toggleCheckboxValue}
                        />
                        <span>{t('after_deliver_status')}</span>
                        <Checkbox
                            checked={is219Checked}
                            onClick={() =>{toggle219CheckboxValue(); handleClick();}}
                        />
                        <span>{t('include_219_status')}</span>
                    </div>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleSearch(dateFrom, dateTo)}
                        className={classes.buttonStyle}
                        disabled={disable}
                    >
                        {t('search')}
                    </Button>
                    {isShown && <div>
                        <ExcelFile
                      filename= "States List"
                      element={
                          <Button 
                          variant="contained" 
                          color="primary"
                          disabled={isChecked ? rows203.length <= 0 : is219Checked ? rows219.length <= 0 : rows.length <= 0}
                          className={classes.buttonStyle}
                          >
                              {t('download_excel')}
                          </Button>                          
                      }
                  >                    
                      <ExcelSheet data={isChecked ? rows203 : is219Checked ? rows219 : rows} name="Statesasd List">
                          <ExcelColumn label="order_sn" value="order_sn"/>
                          <ExcelColumn label="tno" value="tno"/>
                          <ExcelColumn label="reference" value="reference"/>
                          <ExcelColumn label="warehouse" value="warehouse"/>
                          <ExcelColumn label="pathTime" value="pathTime"/>
                          <ExcelColumn label="shipping_staff_id" value="shipping_staff_id"/>
                          <ExcelColumn label="internal_account_number" value="internal_account_number"/>
                          <ExcelColumn label="shipper" value="shipper"/>
                          <ExcelColumn label="bag_no" value="bag_no"/>
                          <ExcelColumn label="zip" value="zip"/>
                          <ExcelColumn label="address1" value="address1"/>
                          <ExcelColumn label="phone" value="phone"/>
                          <ExcelColumn label="pathTime_display" value="pathTime_display"/>
                          <ExcelColumn label="update_time_display" value="update_time_display"/>
                      </ExcelSheet>
                    </ExcelFile></div>}

                    {newButton && <div>
                        <ExcelFile
                      filename= "States List"
                      element={
                          <Button 
                          variant="contained" 
                          color="primary"
                          disabled={isChecked ? rows203.length <= 0 : is219Checked ? rows219.length <= 0 : rows.length <= 0}
                          className={classes.buttonStyle}
                          >
                              {t('download_excel')}
                          </Button>                          
                      }
                  >                    
                      <ExcelSheet data={isChecked ? rows203 : is219Checked ? rows219 : rows} name="Statesasd List">
                          <ExcelColumn label="tno" value="tno"/>
                          <ExcelColumn label="reference" value="reference"/>
                          <ExcelColumn label="warehouse" value="warehouse"/>
                          <ExcelColumn label="wrong_route_warehouse" value="wrong_route_warehouse"/>
                          <ExcelColumn label="wrong_route_time" value="wrong_route_time_display"/>
                          <ExcelColumn label="parcel_scan_time" value="parcel_scan_time_display"/>
                          <ExcelColumn label="newest_state" value="latest_state"/>
                          <ExcelColumn label="error_message" value="error_message"/>
                      </ExcelSheet>
                    </ExcelFile></div>}

                    {
                        loading &&
                        <div className={classes.buttonStyle}>
                            <CircularProgress color='secondary'/>
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ marginTop: 20 }}>
                    <FormControl component="fieldset">
                        <RadioGroup 
                            value={state} 
                            onChange={handleStateChange}
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap'
                            }}
                        >
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <FormControlLabel value='198' control={<Radio disabled={!isLast}/>} label={t('orderStatus:CUSTOM_RELEASE_DIRECT')+"(198)"} /> 
                                <FormControlLabel value='199' control={<Radio disabled={!isLast}/>} label={t('orderStatus:GATEWAY_TRANSIT')+"(199)"} /> 
                                <FormControlLabel value='200' control={<Radio disabled={!isLast}/>} label={t('orderStatus:PARCEL_SCANNED')+"(200)"} />
                                <FormControlLabel value='202' control={<Radio disabled={!isLast}/>} label={t('orderStatus:IN_TRANSIT')+"(202)"} />
                                <FormControlLabel value='204' control={<Radio disabled={!isLast}/>} label={t('orderStatus:TRANSSHIPMENT')+"(204)"} /> 
                                <FormControlLabel value='206' control={<Radio disabled={!isLast}/>} label={t('orderStatus:WRONG_ADDRESS_FROM_TRANSIT')+"(206)"} /> 
                                <FormControlLabel value='211' control={<Radio disabled={!isLast}/>} label={t('orderStatus:RETURN_OFFICE_FROM_TRANSIT')+"(211)"} /> 
                                <FormControlLabel value='217' control={<Radio disabled={!isLast}/>} label={t('orderStatus:TRANSSHIPMENT_COMPLETE')+"(217)"} /> 
                                <FormControlLabel value='218' control={<Radio disabled={!isLast}/>} label={t('orderStatus:SCANNED_PARCEL_MISSING')+"(218)"} /> 
                                <FormControlLabel value='219' control={<Radio disabled={!isLast}/>} label={t('orderStatus:WRONG_ROUTE_PARCEL')+"(219)"} /> 
                                <FormControlLabel value='226' control={<Radio disabled={!isLast}/>} label={t('orderStatus:DROP_OFF')+"(226)"} /> 
                                <FormControlLabel value='0' control={<Radio disabled={!isLast}/>} label={t('orderStatus:AFTER_PARCEL_SCANNED')+"(203, 214, 215, 216, 218, 226)"} /> 
                            </div>                         
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 20, display: 'flex' }}>
                    <div style={{marginRight:10}} hidden={isChecked || is219Checked}>{t('count')}</div>
                    {
                        count ? <div hidden={isChecked}>{count}</div> : <div hidden={isChecked || is219Checked}>0</div>
                    }
                </Grid>
                <Grid item xs={12} style={{ marginTop: 20 }} hidden={isChecked || is219Checked}>
                    <DataGrid
                        style={{height:500}}
                        loading={isDataLoading}
                        alignItems="center"
                        rows={createRows()}
                        columns={columns}
                        disableColumnFilter 
                        disableColumnMenu
                        pageSize={20}
                        rowsPerPageOptions={[20]}
                        isRowSelectable={false}
                    />
                </Grid>
                <Grid item xs={12} style={{ marginTop: 20 }} hidden={!isChecked}>
                    <DataGrid
                        style={{height:500}}
                        loading={isDataLoading}
                        alignItems="center"
                        rows={createRows()}
                        columns={columns203}
                        disableColumnFilter 
                        disableColumnMenu
                        pageSize={20}
                        rowsPerPageOptions={[20]}
                        isRowSelectable={false}
                    />
                </Grid>
                <Grid item xs={12} style={{ marginTop: 20 }} hidden={!is219Checked}>
                    <DataGrid
                        style={{height:500}}
                        loading={isDataLoading}
                        alignItems="center"
                        rows={createRows()}
                        columns={columns219}
                        disableColumnFilter 
                        disableColumnMenu
                        pageSize={20}
                        rowsPerPageOptions={[20]}
                        isRowSelectable={false}
                    />
                </Grid>
            </Grid>
        </UniDialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleLastStateStatistics(false))
    }
    function createRows(){
        if(isChecked) {
            return rows203.map((row) => {
                const {order_sn, ...rest} = row
                return {id: order_sn, ...rest}
            })
        } else if (is219Checked){
            return rows219.map((row, index) => {
                if(row['wrong_route_time']){
                    row['wrong_route_time_display'] = moment.unix(row['wrong_route_time']).format("MMM DD, YYYY - HH:mm:ss");
                } else {
                    row['wrong_route_time_display'] = '';
                }

                if(row['parcel_scan_time']){
                    row['parcel_scan_time_display'] = moment.unix(row['parcel_scan_time']).format("MMM DD, YYYY - HH:mm:ss");
                } else {
                    row['parcel_scan_time_display'] = '';
                }
                return {id: index, ...row}
            })
        }else {
            return rows.map((row) => {
                row['pathTime_display'] = moment.unix(row['pathTime']).format("MMM DD, YYYY - HH:mm:ss");
                row['update_time_display'] = moment.unix(row['update_time']).format("MMM DD, YYYY - HH:mm:ss");
                if(row['order_sn']) {
                    if(row['order_sn'].indexOf(',') < 0) {
                        row['order_sn'] = row['order_sn'];
                    }
                }
                if(row['tno']) {
                    if(row['tno'].indexOf(',') < 0) {
                        row['tno'] = row['tno'];
                    }
                }
                if(row['internal_account_number']) {
                    if(row['internal_account_number'].indexOf(',') < 0) {
                        row['internal_account_number'] = row['internal_account_number'];
                    }
                }
                if(row['bag_no']) {
                    if(row['bag_no'].indexOf(',') < 0) {
                        row['bag_no'] = row['bag_no'];
                    }
                }
                if(row['phone']) {
                    if(row['phone'].indexOf(',') < 0) {
                        row['phone'] = row['phone'];
                    }
                }
                const {order_sn, ...rest} = row
                return {id: order_sn, ...rest}
            })  
        }
    }
}

export default LastStateStatistics;